import axios from 'axios';




export const getWeixinConfig = params => {
  return axios.get('/yongpai-service/api/jssdk/ticket',{params : params});
};





// WEBPACK FOOTER //
// ./src/api/weixin/index.js